import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { LockModalComponent } from '../../components/lock/lock-modal.component';
import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class PasswordGuard implements CanActivate {

  private readonly _authService = inject(AuthService);
  private readonly _modalService = inject(NgbModal);
  private readonly _logger = inject(NGXLogger);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    this._logger.debug('[PasswordGuard] canActivate');

    if (!environment.production) { return true; }

    const lastAuthenticated = this._authService.lastAuthenticated();
    if (lastAuthenticated) {
      const now = DateTime.now();
      const diff = now.diff(DateTime.fromJSDate(lastAuthenticated), 'seconds').seconds;
      if (diff < 15) { return true; }
    }

    return new Observable<boolean>(observer => {
      const modalRef = this._modalService.open(LockModalComponent, {
        centered: true
      });

      modalRef.result.then(() => {
        this._logger.debug('[PasswordGuard] modal closed');
        observer.next(true);
      }, () => {
        this._logger.debug('[PasswordGuard] modal dismissed');
        observer.next(false);
      });

    });
  }

}
